import { render } from "./MaixClientMessages.vue?vue&type=template&id=685272ee&scoped=true"
import script from "./MaixClientMessages.vue?vue&type=script&lang=js"
export * from "./MaixClientMessages.vue?vue&type=script&lang=js"

import "./MaixClientMessages.vue?vue&type=style&index=0&id=685272ee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-685272ee"]])

export default __exports__